module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red@3x-4c773ac93111c2dfecf843c1f8776edb.png";